import Skeleton from '@mui/material/Skeleton';
import { pxToRem } from 'src/common/utils/fonts';

const rowSkeletonStyle = {
  borderRadius: pxToRem(10),
};

export const TableCellSkeleton = () => (
  <Skeleton variant="rectangular" sx={rowSkeletonStyle} animation="wave" height="1rem" />
);
